import {post_request} from "../axiosFun"

//区域车辆列表
export const get_area_car_list = (params) => {
    params = {
        row:{
            area_id:window.localStorage.getItem("area_id"),
            vin:params.vin,
            page_no:params.page,
            page_size:params.limit
        }
    }
    return post_request("/web/area/get_area_cars",params)
};
// 查看可导入的车辆
export const get_area_car_add = (params) => {
    params = {
        row:{
            area_id:window.localStorage.getItem("area_id"),
            vin:params.vin,
            page_no:params.page,
            page_size:params.limit
        }
    }
    return post_request("/web/area/get_cars",params)
};
// 添加车辆
export const get_area_bind_cars = (params) => {
    params = {
        row:{
            area_id:window.localStorage.getItem("area_id"),
            vins:params
        }
    }
    return post_request("/web/area/bind_cars",params)
};
// 删除车辆
export const del_area_car = (params) => {
    params = {
        row:{
            area_id:window.localStorage.getItem("area_id"),
            vin:params
        }
    }
    return post_request("/web/area/del_area_car",params)
};


// WEBPACK FOOTER //
// ./src/api/region/area_car.js